import { Image, Switch } from "antd";
import DownloadIcon from "../../../assets/icons/DownloadIcon";
import PDF from "../../../assets/images/pdf.svg";
import { mobile_bank_list } from "../../../constants/constants";
import { GetEmployeeDetailsResponseType } from "../../../types";
import { getExtension } from "../../../utils/string";
import InfoItem from "../../common/InfoItem";

type Props = {
  data?: GetEmployeeDetailsResponseType;
};

export default function FinancialInfo({ data }: Props) {
  const employeeDetails = data?.data?.employee;

  return (
    <ul>
      {/* <InfoItem title="TIN">
        {employeeDetails?.member?.profile?.tin_no}
      </InfoItem>
      <InfoItem title="Bank Name">
        {employeeDetails?.member?.profile?.bank_info?.bank_name
          ? underscoreToCapitalizeString(
              employeeDetails?.member?.profile?.bank_info?.bank_name
            )
          : undefined}
      </InfoItem>
      <InfoItem title="Bank Account No.">
        {employeeDetails?.member?.profile?.bank_info?.account_no || "N/A"}
      </InfoItem>
      <InfoItem title="Bank Account Title">
        {employeeDetails?.member?.profile?.bank_info?.bank_account_title}
      </InfoItem>
      <InfoItem title="Branch Name">
        {employeeDetails?.member?.profile?.bank_info?.branch_name}
      </InfoItem>
      <InfoItem title="Routing No">
        {employeeDetails?.member?.profile?.bank_info?.routing_no}
      </InfoItem>
      <InfoItem
        title="Spay Wallet"
        // title="Bkash Number"
      >
        {employeeDetails?.bkash_info?.account_no}
      </InfoItem> */}
      <ul>
        {/* <InfoItem title="TIN">
          {employeeDetails?.member?.profile?.tin_no}
        </InfoItem> */}
        <InfoItem title="TIN">
          <div className="flex items-center justify-between">
            {employeeDetails?.member?.profile?.tin_no || "N/A"}
            {employeeDetails?.member?.profile?.tin_certificate ? (
              <div className="ml-2">
                {
                  <div className="flex flex-col">
                    <Image
                      src={
                        getExtension(
                          employeeDetails?.member?.profile?.tin_certificate
                        ) === "pdf"
                          ? PDF
                          : employeeDetails?.member?.profile?.tin_certificate
                      }
                      width={40}
                      height={30}
                      className="object-cover"
                    />
                    <span className="text-accent flex items-center justify-end gap-1 text-xs mt-1">
                      <a
                        href={employeeDetails?.member?.profile?.tin_certificate}
                        target="_blank"
                        className="-mt-[2px] cursor-pointer"
                        rel="noreferrer"
                        download="TIN Certificate"
                      >
                        <DownloadIcon width={10} height={10} />
                      </a>{" "}
                    </span>
                  </div>
                }
              </div>
            ) : null}
          </div>
        </InfoItem>
      </ul>

      <h6 className="!text-zinc-700 text-xl !font-semibold leading-loose mb-2">
        Bank Account ({employeeDetails?.member?.profile?.bank_list?.length || 0}
        )
      </h6>

      <div className="grid grid-cols-2 gap-4">
        {employeeDetails?.member?.profile?.bank_list?.map((el) => (
          <div className="p-4 bg-white rounded-md outline outline-[0.75px] outline-offset-[-0.75px] outline-slate-100">
            <ul className="space-y-1 text-sm font-medium">
              <li>
                <span className="min-w-[150px] inline-block text-slate-400">
                  Bank Name
                </span>
                <span className="text-slate-600">: {el?.bank_name}</span>
              </li>
              <li>
                <span className="min-w-[150px] inline-block text-slate-400">
                  Account No.
                </span>
                <span className="text-slate-600">: {el?.account_no}</span>
              </li>
              <li>
                <span className="min-w-[150px] inline-block text-slate-400">
                  Account Name
                </span>
                <span className="text-slate-600">
                  : {el?.bank_account_title}
                </span>
              </li>
              <li>
                <span className="min-w-[150px] inline-block text-slate-400">
                  Branch Name
                </span>
                <span className="text-slate-600">: {el?.branch_name}</span>
              </li>
              <li>
                <span className="min-w-[150px] inline-block text-slate-400">
                  Routing No.
                </span>
                <span className="text-slate-600">: {el?.routing_no}</span>
              </li>
            </ul>

            <div className="flex items-center gap-2 mt-2 pt-2 border-t border-slate-100">
              <Switch size="small" checked={!!el?.is_active} disabled />
              <div className="text-slate-400 text-sm font-medium leading-normal">
                Set as Default
              </div>
            </div>
          </div>
        ))}
      </div>

      <h6 className="!text-zinc-700 text-xl !font-semibold leading-loose mb-2 mt-4">
        MFS Account ({employeeDetails?.bkash_list?.length || 0})
      </h6>
      <div className="grid grid-cols-2 gap-4">
        {employeeDetails?.bkash_list?.map((el) => (
          <div className="p-4 bg-white rounded-md outline outline-[0.75px] outline-offset-[-0.75px] outline-slate-100">
            <ul className="space-y-1 text-sm font-medium">
              <li className="mb-2">
                <img
                  className="h-20 w-20 object-contain"
                  src={
                    mobile_bank_list?.find((item) => item?.value === el?.type)
                      ?.logo
                  }
                  alt=""
                />
              </li>
              <li>
                <span className="min-w-[150px] inline-block text-slate-400">
                  Account No.
                </span>
                <span className="text-slate-600">: {el?.account_no}</span>
              </li>
            </ul>

            <div className="flex items-center gap-2 mt-2 pt-2 border-t border-slate-100">
              <Switch size="small" checked={!!el?.is_active} disabled />
              <div className="text-slate-400 text-sm font-medium leading-normal">
                Set as Default
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* {data?.data?.employee?.status !== "invited" && (
        <EditButtonEmployee type="Financial" />
      )} */}
    </ul>
  );
}
